import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module engine/view/observer/arrowkeysobserver
 */
import Observer from './observer.js';
import BubblingEventInfo from './bubblingeventinfo.js';
import { isArrowKeyCode } from '@ckeditor/ckeditor5-utils';
/**
 * Arrow keys observer introduces the {@link module:engine/view/document~Document#event:arrowKey `Document#arrowKey`} event.
 *
 * Note that this observer is attached by the {@link module:engine/view/view~View} and is available by default.
 */
var ArrowKeysObserver = /*#__PURE__*/function (_Observer) {
  _inherits(ArrowKeysObserver, _Observer);
  var _super = _createSuper(ArrowKeysObserver);
  /**
   * @inheritDoc
   */
  function ArrowKeysObserver(view) {
    var _this;
    _classCallCheck(this, ArrowKeysObserver);
    _this = _super.call(this, view);
    _this.document.on('keydown', function (event, data) {
      if (_this.isEnabled && isArrowKeyCode(data.keyCode)) {
        var eventInfo = new BubblingEventInfo(_this.document, 'arrowKey', _this.document.selection.getFirstRange());
        _this.document.fire(eventInfo, data);
        if (eventInfo.stop.called) {
          event.stop();
        }
      }
    });
    return _this;
  }
  /**
   * @inheritDoc
   */
  _createClass(ArrowKeysObserver, [{
    key: "observe",
    value: function observe() {}
    /**
     * @inheritDoc
     */
  }, {
    key: "stopObserving",
    value: function stopObserving() {}
  }]);
  return ArrowKeysObserver;
}(Observer);
export { ArrowKeysObserver as default };